export default {
  name: 'meta',
  namespaced: true,
  state: {
    meta: null,
  },
  getters: {
    getHeaderTitle(state) {
      let result = null
      let temp = state.meta?.title || ''
      temp = temp.split(' | ')
      // 타이틀 디폴트값일 경우 null
      if (temp.length > 1) {
        result = temp[0]
      }
      return result
    },
  },
  mutations: {
    set(state, m) {
      state.meta = m
    },
  },
  actions: {
    set({ commit }, m) {
      commit('set', m)
    },
  },
}
